import { INPUT_TYPES } from '../utils/constants';
import { default as GALLERY_CONSTS } from '../../common/constants';
import { createOptions } from '../utils/utils';
export default {
    title: 'Slide Animation',
    isRelevant: function (sp) {
        return sp.scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL &&
            sp.groupSize === 1 &&
            sp.cubeImages &&
            sp.layoutParams.cropRatio === '100%/100%';
    },
    isRelevantDescription: 'Set a Horizontal gallery ("Scroll Direction" as "Horizontal"), set "Max Group Size" to "1" and set "Crop Images" to true.',
    type: INPUT_TYPES.OPTIONS,
    default: GALLERY_CONSTS.slideAnimations.SCROLL,
    options: createOptions('slideAnimations'),
    description: "Choose the slide animation effect to be used when navigating between items in a slideshow",
};
//# sourceMappingURL=slideAnimation.js.map